(() => {
  const animateChars = (lines, delay) => {
    if (!lines || lines.length === 0) return;

    let coeff = lines.length <= 3 ? 0.2 : 0.1;

    lines.forEach((line, lineIndex) => {
      line.querySelectorAll(".word").forEach((word) => {
        word.classList.add("animated");
        word.style.animationDelay = `${delay + lineIndex * coeff}s`;
      });
    });
  };

  const runSlideAnimation = (activeSlide, delay = 0) => {
    if (!activeSlide) return;

    const lines = activeSlide.querySelectorAll(".line");
    const fadeItems = activeSlide.querySelectorAll(".js-fade");
    if (!lines.length) return;

    activeSlide.querySelectorAll(".word").forEach((word) => {
      word.classList.remove("animated");
      word.style.opacity = "0";
      word.style.transform = "translate3d(0,100%,0)";
    });

    fadeItems.forEach((item) => {
      item.classList.remove("visible");
    });

    animateChars(lines, delay);
    const baseDelay = delay * 1000 + lines.length * 150 + 200;

    fadeItems.forEach((item) => {
      const itemDelay = item.classList.contains("js-fade-after")
        ? baseDelay + 150
        : baseDelay;

      setTimeout(() => {
        item.classList.add("visible");
      }, itemDelay);
    });
  };

  const hideElements = (swiper) => {
    if (!swiper?.slides?.length) return;

    swiper.slides.forEach((slide) => {
      if (slide.classList.contains("swiper-slide-active")) return;

      slide.querySelectorAll(".word").forEach((word) => {
        word.classList.remove("animated");
        word.style.opacity = "0";
        word.style.transform = "translate3d(0,100%,0)";
      });

      slide.querySelectorAll(".js-fade").forEach((item) => {
        item.classList.remove("visible");
      });
    });
  };

  const resetHeadingSplit = (heading) => {
    if (!heading) return;

    if (!heading._originalSplitHtml) {
      heading._originalSplitHtml = heading.innerHTML;
    }

    heading.classList.remove("visible");
    heading.innerHTML = heading._originalSplitHtml;
    heading.style.width = "";
    heading.style.height = "";

    if (heading._splittype) {
      delete heading._splittype;
    }
  };

  const initTextAnimation = (section) => {
    if (!section?.querySelector('[data-animation-type="creative"]')) return;

    // .js-content-slider - swiper class in Testimonials section
    const targetSliderEl = section.querySelector(
      ".js-content-slider, .slideshow__swiper--overlay, .slideshow__swiper--text"
    );
    if (!targetSliderEl || !targetSliderEl.swiper) return;

    if (section._creativeTextAnimationCleanup) {
      section._creativeTextAnimationCleanup();
    }

    const targetSwiper = targetSliderEl.swiper;

    let splitInstances = [];
    let resizeTimeout;
    let animationFrameId;

    const buildSplits = () => {
      const headings = targetSliderEl.querySelectorAll(".js-split-text");
      if (headings.length === 0) return;

      splitInstances = [];

      headings.forEach((heading) => {
        resetHeadingSplit(heading);
      });

      headings.forEach((heading) => {
        const split = new SplitType(heading, { types: "lines, words" });
        splitInstances.push(split);
        heading.classList.add("visible");
      });

      section._splitInstances = splitInstances;
    };

    const replayActiveSlideAnimation = (delay = 0) => {
      hideElements(targetSwiper);
      cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(() => {
        const activeSlide = targetSliderEl.querySelector(
          ".swiper-slide-active"
        );
        runSlideAnimation(activeSlide, delay);
      });
    };

    buildSplits();
    replayActiveSlideAnimation();

    let lastWidth = window.innerWidth;
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      if (currentWidth !== lastWidth) {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const activeSlide = targetSliderEl.querySelector(
            ".swiper-slide-active"
          );
          if (!activeSlide) return;

          buildSplits();
          replayActiveSlideAnimation();
        }, 300);
        lastWidth = currentWidth;
      }
    };

    window.addEventListener("resize", handleResize);

    const handleTargetSlideChange = () => {
      replayActiveSlideAnimation(0.5);
    };

    targetSwiper.on("slideChange", handleTargetSlideChange);

    const siblingSliderEl = section.querySelector(
      ".slideshow__swiper--media, .js-media-slider"
    );
    let siblingSwiper = null;
    let handleSiblingSlideChange = null;

    if (siblingSliderEl && siblingSliderEl.swiper) {
      siblingSwiper = siblingSliderEl.swiper;
      handleSiblingSlideChange = () => {
        replayActiveSlideAnimation(0.5);
      };

      siblingSwiper.on("slideChange", handleSiblingSlideChange);
    }

    section._creativeTextAnimationCleanup = () => {
      clearTimeout(resizeTimeout);
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", handleResize);
      targetSwiper.off?.("slideChange", handleTargetSlideChange);

      if (siblingSwiper && handleSiblingSlideChange) {
        siblingSwiper.off?.("slideChange", handleSiblingSlideChange);
      }

      targetSliderEl.querySelectorAll(".js-split-text").forEach((heading) => {
        resetHeadingSplit(heading);
      });

      section._splitInstances = [];
    };
  };

  initTextAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initTextAnimation(event.target);
  });
})();
